import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PlayerBookingCalendar from '../components/player-booking-calendar';
import {push} from 'connected-react-router';
import queryString from 'querystring';
import {addToBookingQueue, filterBookingFieldId, bookingSlotSelected, bookingMultiSlotsSelected, showBookingSlotModal, hideBookingSlotModal, newBooking, saveBooking, bookingSelected, purchaseVideo, acceptPrivacy, getSlots, getVideosStore, getVideosStorePartnerVideo, deleteBooking, setPlayerVideoStoreActiveTab, startBookingTopUp, startGuestTopUp, restoreBookingTopupContext, getPlayerAffiliations} from '../actions/player';
import {showMessage} from '../actions/messages';
import {getBookingTopupResume} from '../util/booking-topup-resume';

const parsePlannerDate = value => {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const parsed = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const mapStateToProps = ({player: {filterBookableFields, selectedPartner, selectedPartnerFields, slots, isBookingSlotModalVisible, bookingSlot, bookingSlots, bookingFieldId, bookings, booking, affiliations, affiliationsStatus}, login: {token, profile}}, ownProps) => ({
  isLogged: token !== null,
  selectedPartner,
  selectedPartnerFields,
  slots,
  isBookingSlotModalVisible,
  bookingSlot,
  bookingSlots,
  bookingFieldId,
  bookings,
  booking,
  profile,
  token,
  filterBookableFields,
  affiliations,
  affiliationsStatus,
  resumeSlotId: new URLSearchParams(ownProps.location.search).get('resumeSlotId'),
  initialPlannerDate: parsePlannerDate(new URLSearchParams(ownProps.location.search).get('date'))
});

const mapDispatchToProps = dispatch => ({
  bookingSlotSelected: ev => {
    if (new Date(ev.slot.startDatetime) < Date.now()) {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_HAS_PASSED'));
    } else if (ev.slot.state === 'reserved') {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_RESERVED'));
    }
      else if (ev.slot.state === "unavailable") {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_UNAVAILABLE'));
    } else if (ev.slot.bookingId && ev.booking) {
      dispatch(bookingSlotSelected(ev.slot));
      dispatch(bookingSelected(ev.booking));
      dispatch(showBookingSlotModal());
    } else {
      const topupResume = getBookingTopupResume();
      const resumedDraft = topupResume && String(topupResume.slotId) === String(ev.slot.slotId) ? topupResume.bookingDraft : null;
      dispatch(bookingSlotSelected(ev.slot));
      dispatch(newBooking(resumedDraft || {description: null, payment: false, playersNumber: 1, otherPlayers: [''], slots: [ev.slot.slotId], rtvOrAcademy: false, invitedPlayers: [], invitedGuests: []}));
      dispatch(showBookingSlotModal());
    }
  },
  bookingMultiSlots: slots => {
    dispatch(bookingMultiSlotsSelected(slots));
    dispatch(newBooking({description: null, payment: false, playersNumber: 1, otherPlayers: [''], slots: slots.map(s => s.slotId), rtvOrAcademy: false, invitedPlayers: [], invitedGuests: []}));
    dispatch(showBookingSlotModal());
  },
  addToBookingQueue: slotId => {
    dispatch(addToBookingQueue(slotId));
  },
  hideBookingSlotModal: () => {
    dispatch(hideBookingSlotModal());
  },
  saveBooking: booking => dispatch(saveBooking(booking)),
  requestDelete: phoneNumber => {
      dispatch(showMessage('BOOKINGS', 'BOOKING_HOW_CANCEL', {phoneNumber}));
  },
  purchaseVideo: slots => {
    dispatch(purchaseVideo(slots));
  },
  showMessage: (title, body) => {
    dispatch(showMessage(title, body));
  },
  acceptPrivacy: () => {
    dispatch(acceptPrivacy());
  },
  getSlotsByWeek: (partnerId, fieldId) => targetDate => {
    return dispatch(getSlots(partnerId, fieldId, targetDate));
  },
  getSlotsByDay: (partnerId, fieldId) => targetDate => {
    return dispatch(getSlots(partnerId, fieldId, targetDate, 'field', 'DAY'));
  },
  showVideoStore: (partnerUid, fieldId, fromDatetime, toDatetime) => {
    dispatch(getVideosStore(partnerUid, fieldId, null, fromDatetime, toDatetime));
    dispatch(getVideosStorePartnerVideo(partnerUid));
    const params = Object.fromEntries(Object.entries({fieldId, fromDatetime, toDatetime}).filter(([_, v]) => v !== null));
    if (new Date(fromDatetime) > new Date()) {
      dispatch(setPlayerVideoStoreActiveTab('soon'));
    }
    else{
      dispatch(setPlayerVideoStoreActiveTab('watch_now'));
    }
    dispatch(push(`/player-video-store-partner?${queryString.stringify(params)}`));
  },
  showCalendar: (partnerId, fieldId = null) => () => {
    dispatch(filterBookingFieldId(fieldId));
    dispatch(getSlots(partnerId, fieldId, new Date()));
    dispatch(push('/player-booking-calendar'));
  },
  startBookingTopUp: (amount, slotId, bookingDraft = null, recoveryContext = {}) => dispatch(startBookingTopUp(amount, slotId, bookingDraft, recoveryContext)),
  startGuestTopUp: (bookingDraft, amount, slotId, recoveryContext) => dispatch(startGuestTopUp(bookingDraft, amount, slotId, recoveryContext)),
  restoreBookingTopupContext: () => dispatch(restoreBookingTopupContext('field')),
  refreshPlayerAffiliations: () => dispatch(getPlayerAffiliations()),
  goToProfile: () => {
    dispatch(push('/player-profile'));
  },
  deleteBooking: (bookingId, partnerId, multiBooking) => {
    dispatch(deleteBooking(bookingId, partnerId, multiBooking));
  },
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerBookingCalendar));
